export const environment = {
  production: true,
  apiEndPointprod: 'https://lpu-backend-prod.azurewebsites.net',
  apiEndPoint: 'https://lpu-backend-prod.azurewebsites.net',
  //apiEndPoint: 'https://185.64.149.141:5005'
};
